var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11H0V12H12V11Z",
    fill: "#031434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.682 10.0655C1.7605 10.0655 1.8415 10.0527 1.923 10.0257L4.026 9.3247C4.17325 9.2757 4.307 9.19295 4.417 9.0832L10.6163 2.88395C11.1045 2.3957 11.1045 1.60445 10.6163 1.1162L9.884 0.38395C9.63975 0.1397 9.32 0.0177002 9 0.0177002C8.68 0.0177002 8.36025 0.1397 8.116 0.3837L1.917 6.58295C1.80725 6.6927 1.7245 6.82645 1.6755 6.97395L0.9745 9.07695C0.806 9.5817 1.196 10.0655 1.682 10.0655ZM2.624 7.2902L8.82325 1.09095C8.88375 1.03045 8.95275 1.0177 9 1.0177C9.04725 1.0177 9.11625 1.03045 9.17675 1.09095L9.909 1.8232C10.0065 1.9207 10.0065 2.0792 9.909 2.1767L3.70975 8.37595L2.081 8.91895L2.624 7.2902Z",
    fill: "#031434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.344fca53564aeb3bc79cb4bc2f57bca7.svg";
export { ForwardRef as ReactComponent };